import React from 'react';
import { Icon } from '@amzn/storm-ui';
import { star, solidStar } from '@amzn/storm-ui-icons';
import { TitleIconContainer } from '../styles';
import { PageTitleIconProps } from '../types';
import { usePageTitleIconData } from './ajaxPageTitleIconInfo';
import { SnackbarContainer, ToastBanner } from '../../ToastBanner/ToastBanner';
import { BANNER_TYPE } from '../../../../../app/slice';

export type PageTitleIconComponentProps = PageTitleIconProps & {
  pageNameTagExists: boolean;
};

export const PageTitleIcon: React.VFC<PageTitleIconComponentProps> = ({
  id,
  pageNameTagExists,
  isActive,
  iconAPI,
  apiCallFailureMessage,
  apiCallSuccessMessage,
  iconStatusAPI,
}) => {
  const {
    toggled,
    showSuccessBanner,
    showFailBanner,
    requestFailMessage,
    requestSuccessMessage,
    failureBannerCloseEvent,
    successBannerCloseEvent,
    pageTitleIconToggleEvent,
  } = usePageTitleIconData({
    iconAPI,
    id,
    isActive,
    apiCallFailureMessage,
    apiCallSuccessMessage,
    iconStatusAPI,
  });

  if (!iconAPI) return null;
  if (typeof isActive == 'undefined' && !iconStatusAPI) return null;

  return (
    <>
      <TitleIconContainer
        id={id}
        pageNameTagExists={pageNameTagExists}
        onClick={() => pageTitleIconToggleEvent()}
        role="button"
        toggled={toggled}
      >
        <Icon type={toggled ? solidStar : star} size="xs" blockSize={true} />
      </TitleIconContainer>
      {requestFailMessage && showFailBanner && (
        <SnackbarContainer>
          <ToastBanner
            banner={{
              id: `${id}-failureMessage`,
              message: requestFailMessage,
              type: BANNER_TYPE.ERROR,
              withCloseButton: true,
            }}
            bannerClosed={failureBannerCloseEvent}
            autoClose={true}
          />
        </SnackbarContainer>
      )}
      {requestSuccessMessage && showSuccessBanner && (
        <SnackbarContainer>
          <ToastBanner
            banner={{
              id: `${id}-successMessage`,
              message: requestSuccessMessage,
              type: BANNER_TYPE.SUCCESS,
              withCloseButton: false,
            }}
            bannerClosed={successBannerCloseEvent}
            autoClose={true}
          />
        </SnackbarContainer>
      )}
    </>
  );
};
